/**
 * Created by esenckewitch on 30.07.2026
 */

cleverapps.CrossPromo = function () {
    this.load();

    this.promotion = [];
    this.gamesInfo = [];

    connector.platform.whenConnected(() => this.updatePromotion());
    cleverapps.settings.on("updateLanguage", () => this.updatePromotion(), this);
};

cleverapps.CrossPromo.prototype.getCatalog = function () {
    return bundles.newcrosspromo.jsons.crosspromo_json.getJson();
};

cleverapps.CrossPromo.prototype.getEditorial = function () {
    return bundles.newcrosspromo.jsons.editorial_json.getJson();
};

cleverapps.CrossPromo.prototype.updatePromotion = function () {
    connector.platform.listGames().then((gamesInfo) => {
        this.gamesInfo = gamesInfo || [];
        this.promotion = this.listPromotions();
    });
};

cleverapps.CrossPromo.prototype.isAvailable = function () {
    return connector.platform.canSwitchGame() && !cleverapps.flags.get("noCrossPromo");
};

cleverapps.CrossPromo.prototype.havePromotion = function () {
    if (!cleverapps.config.debugMode) {
        return false;
    }

    return this.isAvailable() && this.promotion && this.promotion.length
        && cleverapps.user.checkAvailable(cleverapps.config.availables.CROSS_PROMO);
};

cleverapps.CrossPromo.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.CROSSPROMO) || {};
    this.shownMarkDate = data.shownMarkDate;
};

cleverapps.CrossPromo.prototype.saveShownMarkTime = function () {
    this.shownMarkDate = Date.now();
    cleverapps.dataLoader.save(DataLoader.TYPES.CROSSPROMO, {
        shownMarkDate: this.shownMarkDate
    });
};

cleverapps.CrossPromo.prototype.getPlatformConfig = function (config) {
    const source = connector.info.source;

    switch (source) {
        case "macos":
            return config.ios;
        case "sp_mbga":
            return config.mbga;
        case "test":
            return {};
        case "cleverapps":
            return {};
        default:
            return config[source];
    }
};

cleverapps.CrossPromo.prototype.hasMark = function () {
    return this.havePromotion()
        && (!this.shownMarkDate
            || Date.now() - this.shownMarkDate >= cleverapps.CrossPromo.SHOW_MARK_INTERVAL);
};

cleverapps.CrossPromo.prototype.getDisplayName = function (config) {
    const titles = config.titles || {};
    return titles[cleverapps.settings.language] || titles.en || config.name;
};

cleverapps.CrossPromo.prototype.getGenre = function (game) {
    const editorial = this.getEditorial();

    const override = (editorial.gameGenre || {})[game];
    if (override) {
        return override;
    }

    const section = (editorial.genres || []).find((item) => (item.games || []).indexOf(game) !== -1);
    return section && section.title;
};

cleverapps.CrossPromo.prototype.getBanner = function (game, type) {
    const frames = bundles.newcrosspromo.frames;
    const localized = `${game}_${type}_${cleverapps.settings.language}`;
    const english = `${game}_${type}`;

    return frames[localized] || frames[english];
};

cleverapps.CrossPromo.prototype.getIcon = function (game) {
    return bundles.newcrosspromo.frames[`icon_${game}`];
};

cleverapps.CrossPromo.prototype.listTopGames = function () {
    return (this.getEditorial().featured || []).concat(this.listGames());
};

cleverapps.CrossPromo.prototype.listGames = function () {
    const editorial = this.getEditorial();
    const games = {};

    (editorial.featured || []).forEach((game) => {
        games[game] = true;
    });
    (editorial.genres || []).forEach((section) => {
        (section.games || []).forEach((game) => {
            games[game] = true;
        });
    });

    return Object.keys(games);
};

cleverapps.CrossPromo.prototype.listPromotions = function () {
    return this.listGames().map((game) => this.createPromotion(game)).filter(Boolean);
};

cleverapps.CrossPromo.prototype.createPromotion = function (game) {
    const json = this.getCatalog();

    if (game === cleverapps.config.name) {
        return;
    }

    const config = json[game];
    if (!config) {
        return;
    }

    const platformConfig = this.getPlatformConfig(config);
    if (!platformConfig || !cleverapps.config.debugMode && platformConfig.debug) {
        return;
    }

    const editorial = this.getEditorial();

    const promo = {
        id: game,
        name: this.getDisplayName(config),
        genre: this.getGenre(game),
        players: (editorial.players || {})[game],
        badge: (editorial.badge || {})[game],
        link: connector.utils.guessPlatformURL({
            config,
            debugMode: false
        }) || config.deployment,
        payload: undefined
    };

    if (!promo.link) {
        return;
    }

    switch (connector.info.source) {
        case "instant": {
            const projectBusiness = cleverapps.config.instant && cleverapps.config.instant.business || cleverapps.config.business;
            const promoBusiness = config.instant && config.instant.business || config.business;

            promo.link = config.instant && config.instant.appId;
            promo.payload = { channel: cleverapps.config.name };

            if (projectBusiness !== promoBusiness) {
                return;
            }
            break;
        }
        case "msstart":
            promo.link = config.msstart && config.msstart.appId;
            promo.payload = { channel: cleverapps.config.name };
            break;
        case "android":
            promo.link = cleverapps.addSearchParams(promo.link, {
                utm_campaign: cleverapps.config.name
            });
            break;
        case "yandex": {
            const appId = config.yandex && config.yandex.appId;
            const gameInfo = this.gamesInfo.find((info) => info.appID === appId);
            if (!gameInfo) {
                return;
            }

            promo.link = cleverapps.addSearchParams(gameInfo.link, {
                payload: cleverapps.config.name
            });
            promo.imageURL = gameInfo.imageURL;
            break;
        }
        default:
            promo.link = cleverapps.addSearchParams(promo.link, {
                channel: cleverapps.config.name
            });
            break;
    }

    return promo;
};

cleverapps.CrossPromo.prototype.listFeatured = function () {
    const featured = this.getEditorial().featured || [];

    return featured.map((game) => {
        const promo = this.createPromotion(game);
        if (!promo) {
            return null;
        }

        promo.banner = this.getBanner(game, "featured");
        promo.icon = this.getIcon(game);
        return promo.banner ? promo : null;
    }).filter(Boolean);
};

cleverapps.CrossPromo.prototype.listGenres = function () {
    const genres = this.getEditorial().genres || [];

    return genres.map((section) => ({
        title: section.title,
        promotions: (section.games || []).map((game) => {
            const promo = this.createPromotion(game);
            if (!promo) {
                return null;
            }

            promo.banner = this.getBanner(game, "genre");
            return promo.banner ? promo : null;
        }).filter(Boolean)
    })).filter((section) => section.promotions.length > 0);
};

cleverapps.CrossPromo.OpenCrossPromoWindow = function () {
    if (!cleverapps.crossPromo.havePromotion()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "CrossPromoWindow",
        stack: true,
        action: function (f) {
            new NewCrossPromoWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

cleverapps.CrossPromo.SHOW_MARK_INTERVAL = cleverapps.parseInterval(cleverapps.config.debugMode ? "20 minute" : "7 days");
